import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { gdprService } from '../../api/services';

const Gdpr: React.FC = () => {
  const [busy, setBusy] = useState(false);

  const doExport = async () => {
    setBusy(true);
    try {
      const blob = await gdprService.exportZip();
      const url = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement('a'), { href: url, download: 'greenbill-gdpr-export.zip' });
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Erreur export');
    } finally { setBusy(false); }
  };

  const anonymizeMe = async () => {
    const confirm = window.prompt(
      'Cette action est IRRÉVERSIBLE. Toutes vos données personnelles seront effacées, et vous serez déconnecté.\n\nTapez "SUPPRIMER" pour confirmer.',
    );
    if (confirm !== 'SUPPRIMER') return;
    setBusy(true);
    try {
      await gdprService.anonymizeMe();
      toast.success('Compte anonymisé. Déconnexion…');
      localStorage.clear();
      setTimeout(() => { window.location.href = '/login'; }, 1500);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Erreur');
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h2 className="text-lg font-semibold">Conformité RGPD / INPDP</h2>
        <p className="text-sm text-gray-500">
          Loi organique 2004-63 relative à la protection des données personnelles en Tunisie.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 space-y-3">
        <h3 className="font-semibold">Exporter toutes les données de ma société</h3>
        <p className="text-sm text-gray-600">
          Télécharger une archive ZIP contenant clients, articles, documents, paiements, mouvements de stock au format JSON.
        </p>
        <button onClick={doExport} disabled={busy}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50">
          {busy ? 'Préparation…' : 'Télécharger l\'export ZIP'}
        </button>
      </div>

      <div className="bg-white p-6 rounded-xl border border-red-200 space-y-3">
        <h3 className="font-semibold text-red-700">Anonymiser mon compte utilisateur</h3>
        <p className="text-sm text-gray-600">
          Remplace nom, email et mot de passe par des valeurs anonymes.
          Les tokens de rafraîchissement sont révoqués. Les données métier
          de la société (factures, clients, articles) sont conservées pour les
          obligations comptables (10 ans).
        </p>
        <button onClick={anonymizeMe} disabled={busy}
                className="px-4 py-2 border border-red-300 text-red-700 rounded-lg font-semibold hover:bg-red-50 disabled:opacity-50">
          Anonymiser mon compte (irréversible)
        </button>
      </div>
    </div>
  );
};

export default Gdpr;
